/** Ідентифікатор групи, яку створив або перейменував користувач (прототип v4 uid()): «g-» і випадковий суфікс. */
export const newGroupId = (): string => `g-${Date.now().toString(36)}${Math.random().toString(36).slice(2, 6)}`;

/** Ідентифікатор групи після перейменування: група користувача лишає свій, стандартна (переклад за ідентифікатором) отримує новий. */
export const renamedGroupId = (id: string): string => (id.startsWith('g-') ? id : newGroupId());
